import { Inject, Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { FeatureConfigFacade } from '@common/data-access-feature-config';
import { CmsDataService, cmsDataUrl } from '@common/data-access-shared';
import { RUNTIME_CONFIG } from '@common/util-foundation';
import { CmsData, CmsPage, RuntimeConfig } from '@common/util-models';
import { combineLatest, Observable } from 'rxjs';
import { map, take, switchMap } from 'rxjs/operators';
import { QuotesFacade } from '../facades/quotes.facade';

enum ClientIdentifier {
  salesDandG = '1',
}
@Injectable({
  providedIn: 'root',
})
export class QuoteCmsPageResolver implements Resolve<Observable<CmsData>> {
  constructor(
    private cmsDataService: CmsDataService,
    private featureConfigFacade: FeatureConfigFacade,
    private quotesFacade: QuotesFacade,
    @Inject(RUNTIME_CONFIG) private runtimeConfig: RuntimeConfig
  ) {}

  resolve(): Observable<CmsData> {
    const baseUrl = cmsDataUrl[CmsPage.Quote]?.url;
    return combineLatest([
      this.quotesFacade.isHeating$,
      this.featureConfigFacade.clientConfig$(),
    ]).pipe(
      map(([heating, { policyFeaturesClientIdentifier }]) => {
        if (
          heating &&
          policyFeaturesClientIdentifier === ClientIdentifier.salesDandG
        ) {
          return `${baseUrl}/heating-policy-features`;
        }
        const cmsPolicyFeaturePath = `${baseUrl}/${'policy-features-'}${policyFeaturesClientIdentifier}`;

        return this.runtimeConfig.cmsForceJsonExtension
          ? `${cmsPolicyFeaturePath}.json`
          : cmsPolicyFeaturePath;
      }),
      take(1),
      switchMap((quoteCmsPageUrl) =>
        this.cmsDataService.getCmsData({
          id: CmsPage.Quote,
          url: quoteCmsPageUrl,
        })
      )
    );
  }
}
